import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MeasurementUnitTypeMockService {
  #mockDataChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public onDataFrom38DLReceived(): Observable<string> {
    return new Observable(observer => {
      this.mockDataChanged().subscribe(() => {
        observer.next('in');
        setTimeout(() => observer.next(null), 1000);
      });
    });
  }

  public mockDataChanged(): Observable<boolean> {
    return this.#mockDataChangedSubject;
  }
}
